import React from 'react'
import { BsTelephone } from 'react-icons/bs';
import { Link } from 'react-router-dom';

export default function GetTouch() {
    return (
        <div className="container md:mt-24 mt-16">
            <div className="grid grid-cols-1 text-center">
                <h3 className="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">Have Question ? Get in touch!</h3>

                <p className="text-slate-400 max-w-xl mx-auto">We are a huge marketplace dedicated to connecting great artists of all Solar Exchange with their fans and unique token collectors!</p>

                <div className="mt-6">
                    <Link to="/helpcenter-support" className="btn bg-hover-tone hover:border-hover-tone border-tone hover:border-hover-tone text-white rounded-full me-2 mt-2 inline-flex items-center"><BsTelephone className='me-1'/>  Contact us</Link>
                </div>
            </div>
        </div>
    )
}
